// Timer (TypeScript)
import {ActiveTimer, TimerEntry} from '../types/components';

export class Timer {
  // NOTE: storage value is not reset on sign out,
  // use StorageService instead of localStorage directly
  private static readonly STORAGE_KEY = 'falcon_active_timer';
  private _active: ActiveTimer | null = null;

  constructor() {
    this.loadFromStorage();
  }

  active(): ActiveTimer | null {
    return this._active;
  }

  start(issueKey: string, description: string, startDate: Date): void {
    this._active = {issueKey, description, start: startDate};
    this.saveToStorage();
  }

  adjustStart(newStart: Date): void {
    if (this._active) {
      this._active.start = newStart;
      this.saveToStorage();
    }
  }

  setIssueKey(issueKey: string): void {
    if (this._active) {
      this._active.issueKey = issueKey;
      this.saveToStorage();
    }
  }

  setDescription(description: string): void {
    if (this._active) {
      this._active.description = description;
      this.saveToStorage();
    }
  }

  elapsedSec(): number {
    if (!this._active) {
      return 0;
    }
    return Math.max(0, Math.floor((Date.now() - this._active.start.getTime()) / 1000));
  }

  stop(): TimerEntry | null {
    if (!this._active) {
      return null;
    }
    const entry: TimerEntry = {...this._active, end: new Date()};
    this._active = null;
    this.saveToStorage();

    return entry;
  }

  isRunning(): boolean {
    return !!this._active;
  }

  // TODO replace localStorage with storage service
  private saveToStorage(): void {
    try {
      if (this._active) {
        const activeTimerData = {
          issueKey: this._active.issueKey,
          description: this._active.description,
          start: this._active.start.toISOString()
        };
        localStorage.setItem(Timer.STORAGE_KEY, JSON.stringify(activeTimerData));
      } else {
        localStorage.removeItem(Timer.STORAGE_KEY);
      }
    } catch (error) {
      console.warn('Failed to save timer to storage:', error);
    }
  }

  // TODO replace localStorage with storage service
  private loadFromStorage(): void {
    try {
      const storedData = localStorage.getItem(Timer.STORAGE_KEY);
      if (storedData) {
        const parsed = JSON.parse(storedData);
        this._active = {
          issueKey: parsed.issueKey,
          description: parsed.description,
          start: new Date(parsed.start)
        };
      }
    } catch (error) {
      console.warn('Failed to load timer from storage:', error);
      localStorage.removeItem(Timer.STORAGE_KEY);
    }
  }
}